import Email from './email.vue';

export default Email;
